export { DrillFooterSentenceSpeechView } from "#drill-footer-sentence-speech-view";
